import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function ParallaxSections() {
    const sections = [
        {
            sectionName: "Websites", image: "image1.jpg", style: {
                backgroundColor: "rgba(0, 0, 0, 0.4)",
            }
        },
        { sectionName: "UI/UX Design", image: "image2.jpg", style: { backgroundColor: "rgba(0, 0, 0, 0.4)", } },
        { sectionName: "Full-stack Apps", image: "image3.jpg", style: { backgroundColor: "rgba(0, 0, 0, 0.4)", } },
        { sectionName: "Mobile Apps", image: "image4.jpg", style: { backgroundColor: "rgba(0, 0, 0, 0.4)", } },
        { sectionName: "Computer Hardware", image: "image5.jpg", style: { backgroundColor: "rgba(0, 0, 0, 0.4)", } },
    ];

    useEffect(() => {
        const getRatio = (el) =>
            window.innerHeight / (window.innerHeight + el.offsetHeight);

        gsap.utils.toArray(".parallax-section").forEach((section, i) => {
            const bg = section.querySelector(".bg-image");

            if (bg) {
                bg.style.backgroundImage = `url(/images/${sections[i].image})`;
            }

            gsap.fromTo(
                bg,
                {
                    backgroundPosition: i
                        ? `50% ${-window.innerHeight * getRatio(section)}px`
                        : "50% 0px",
                },
                {
                    backgroundPosition: `50% ${window.innerHeight * (1 - getRatio(section))}px`,
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: i ? "top bottom" : "top top",
                        end: "bottom top",
                        scrub: true,
                        invalidateOnRefresh: true,
                    },
                }
            );
        });
    }, []);

    return (
        <div>
            {sections.map((item, i) => (
                <section
                    key={i}
                    className="parallax-section relative h-screen flex justify-center overflow-x-hidden"
                >
                    <div
                        className="bg-image flex items-center justify-center absolute z-[1] w-full h-full bg-no-repeat bg-cover"
                    >
                        <h1 className="text-white text-4xl font-semibold drop-shadow-xl"
                        style={item.style}>
                            {item.sectionName}
                        </h1>
                    </div>
                </section>
            ))}
        </div>
    );
}
